import { render, staticRenderFns } from "./RelatorioFaturamentoRoute.vue?vue&type=template&id=42b94d88"
import script from "./RelatorioFaturamentoRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioFaturamentoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports